const router = require('./router');
const { rest } = require('@karpeleslab/klbfw');

// export renderToString function for server side rendering
global.renderToString = router.renderToString;

// export rest function for debugging
if(typeof window !== 'undefined') {
    window.rest = rest;
}

// start app if it in the browser
if(typeof window !== 'undefined') {
    // Start main application here
    router.run();
}
